import { ContentTypeFilterClause, ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { ContentFiltersKeys } from '../ContentFilters';
import { getBackgroundJobsDefaultFilters } from './getDefaultFilters';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { BackgroundJobsService } from '../../../backgroundJob/types/BackgroundJobs';
import { BackgroundJobContentType } from '../ContentTypes';

export const BackgroundJobDefinition: ExplorableItemDefinition = {
  itemType: 'backgroundJob',
  pluralName: Messages.backgroundJobs,
  emptyStateMessage: Messages.backgroundJobsEmptyMessage,
  contentFilterKeys: [
    ContentFiltersKeys.backgroundJobStatus,
    ContentFiltersKeys.backgroundJobTaskType,
    ContentFiltersKeys.backgroundJobTimeRange,
    ContentFiltersKeys.showSystemJobs,
  ],
  defaultFilters: getBackgroundJobsDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['backgroundJob']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return BackgroundJobsService.all().withExtraParams(BackgroundJobContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
